import MainModal from '@/common/components/base/modal/Modal.tsx';
import { MainModalProps } from '@/common/components/base/modal/Modal.type.ts';
import GreenCheckIcon from '@/common/assets/icons/greenCheckIcon.svg?react';
import { Center } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import Button from '@/common/components/base/button/Button.tsx';
import { useNavigate } from 'react-router-dom';
import { AUTH_LINKS } from '@/modules/Auth/AUTH_LINKS.ts';

export default ({ open }: Omit<MainModalProps, 'closeModal'>) => {
  return (
    <MainModal open={open} closeModal={() => {}}>
      <RegisterSuccessfulModal />
    </MainModal>
  );
};

const RegisterSuccessfulModal = () => {
  const navigate = useNavigate();
  const onButtonClick = () => {
    navigate(AUTH_LINKS.auth);
  };
  return (
    <Center flexDirection="column">
      <Center mb="25px">
        <GreenCheckIcon />
      </Center>
      <Typography>اطلاعات شما با موفقیت ثبت شد.</Typography>
      <Typography mb="25px">
        همکاران ما در اسرع وقت با شما تماس می‌گیرند.
      </Typography>
      <Button mb="20px" onClick={() => onButtonClick()} fullWidth>
        بازگشت به صفحه اصلی
      </Button>
    </Center>
  );
};
